// language=GraphQL
export const ALL_BESTSELLER_SLIDER_BLOCKS_QUERY = `query Query {
  bestsellerSliderBlocks: cmsBestsellerSliderBlocks {
    id
    fluid
  }
}`

// language=GraphQL
export const SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY = `query Query($id: ID!) {
  bestsellerSliderBlock: cmsBestsellerSliderBlock(id: $id) {
    id
    fluid
  }
}`

// language=GraphQL
export const CREATE_BESTSELLER_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsBestsellerSliderBlockInput) {
    bestsellerSliderBlock: createCmsBestsellerSliderBlock(input: $input) {
      id
      fluid
    }
  }`

// language=GraphQL
export const UPDATE_BESTSELLER_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsBestsellerSliderBlockInput) {
    bestsellerSliderBlock: updateCmsBestsellerSliderBlock(input: $input) {
      id
      fluid
    }
  }`

// language=GraphQL
export const DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsBestsellerSliderBlockInput) {
    deleteCmsBestsellerSliderBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsBestsellerSliderBlockInput) {
    forceDeleteCmsBestsellerSliderBlock(input: $input) {
      success
    }
  }`
